module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/video-preview-6ae6cb2cf4fddf96513d64b055ea8b0d.jpg";